/* eslint semi:0 */
import BaseClass from '../../application/BaseClass'
import GoogleSearchVm from '../vms/googleSearchVm'
import GoogleSearchView from '../views/GoogleSearchView'
import { isSupportedForDomain } from '../../application/pageDataObject'
import { make as makeComponent, empty as emptyComponent } from '../../utils/component'

const SEARCH_BAR_FEATURE_ID = 'SearchBar'

class GoogleSearchController extends BaseClass {
  constructor(options = {}) {
    super(...arguments)
    this.vm = GoogleSearchVm.create(options)
  }
}

export default (isSupportedForDomain(SEARCH_BAR_FEATURE_ID)
  ? makeComponent(GoogleSearchController, GoogleSearchView)
  : emptyComponent)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/googleSearchComponent.js